import {PlusIcon} from '@primer/octicons-react'
import {Button, type ButtonProps, IconButton, type IconButtonProps} from '@primer/react'

import {LABELS} from './constants/labels'

export type CreateIssueButtonLoadingProps = {
  label: string
  size?: 'small' | 'medium'
  iconOnly?: boolean
  leadingVisual?: ButtonProps['leadingVisual']
}

export const CreateIssueButtonLoading = ({
  label,
  size = 'medium',
  iconOnly = false,
  leadingVisual,
}: CreateIssueButtonLoadingProps): React.ReactElement | null => {
  if (iconOnly) {
    const icon = (leadingVisual ?? PlusIcon) as IconButtonProps['icon']
    return <IconButton size={size} icon={icon} aria-label={label} loading loadingAnnouncement={LABELS.loadingTooltip} />
  }

  return (
    <Button size={size} loading leadingVisual={leadingVisual} loadingAnnouncement={LABELS.loadingTooltip}>
      {label}
    </Button>
  )
}
